var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('router-link',{attrs:{"to":{ name: 'Controlling' }}},[_vm._v("Zurück")]),_c('div',{staticStyle:{"padding":"20px"}},[_c('unvergessen-detail-card',{attrs:{"heading":_vm.heading}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }